import { useLayoutEffect } from 'react';
import { setTakeoverActive, type TakeoverSource } from '@lib/overlay/mutex';

/**
 * Feeds a takeover's visibility into the overlay mutex
 * (docs/overlays/overlay-system-design.md §6.4). While `active`, coordinated
 * surfaces wait; the one already on screen keeps its grant.
 *
 * A layout effect, so the bit flips during the commit that renders the
 * takeover rather than after paint. `active` is a boolean on purpose: moving
 * between two visible states (maintenance → connection, session-expired →
 * service-unavailable) leaves it true, so the effect does not re-run and the
 * mutex is never unparked in between.
 */
export function useTakeoverFeed(source: TakeoverSource, active: boolean): void {
  useLayoutEffect(() => {
    if (!active) return;
    setTakeoverActive(source, true);
    return () => {
      setTakeoverActive(source, false);
    };
  }, [source, active]);
}
